export { default } from "./details-field-value";
